<template>
  <section
    v-if="getAttributesActive && attributeListingFilterGroups.length > 0"
    class="attribute-listing-filters"
  >
    <div class="attribute-listing-filters-wrapper">
      <BaseGroupListingFilters
        v-if="attributeListingFilterGroups.length > 0"
        :base-group-combos="attributeListingFilterGroups"
      >
      </BaseGroupListingFilters>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseGroupListingFilters from '../Components/BaseGroupListingFilters'

export default {
  name: 'AttributeListingFilters',
  props: [],
  components: {
    BaseGroupListingFilters
  },
  computed: {
    ...mapGetters([
      'getListingAttributeGroupCombos',
      'getAttributesActive',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getActiveAttributeFilters',
      'config',
      'getListingAttributeGroupCombosWithoutDuplicateValueNames',
      'getAttributeMergeDuplicateValuesByName'
    ]),
    attributeListingFilterGroups () {
      if (this.getAttributeMergeDuplicateValuesByName) {
        return this.getListingAttributeGroupCombosWithoutDuplicateValueNames
      }
      return this.getListingAttributeGroupCombos
    }
  }
}
</script>
